import { KdsCardFile, KdsText } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { type ContextType } from "react";

import { type FileContext } from "@/components/FileUploadAsync/FileUploadAsync.context";
import {
  type OrderGetOrderDetailsOrderItemReadDto,
  type OrderItemDetailsReadDto,
} from "@/config/apiClient";
import { PreMediaUploadField } from "./PreMediaUploadField";

type OrderItem = OrderItemDetailsReadDto | OrderGetOrderDetailsOrderItemReadDto;

interface PreMediaFilesSectionProps {
  orderItem: OrderItem;
  fields: Array<{ id: string }>;
  isUploadingFile: boolean;
  onFileUpload: (
    file: File,
    index: number,
    ctx: ContextType<typeof FileContext>
  ) => Promise<void>;
  ctx: ContextType<typeof FileContext>;
}

export const PreMediaFilesSection = ({
  orderItem,
  fields,
  isUploadingFile,
  onFileUpload,
  ctx,
}: PreMediaFilesSectionProps) => {
  const { t } = useTranslate();

  return (
    <>
      {/* Existing Pre-Media Files */}
      {orderItem.sandboxItem?.preMediaFiles?.map((file) => (
        <KdsCardFile
          key={file.url}
          fileName={file.fileName}
          fileUrl={file.url}
          fileSize={file.size}
          isViewable
        />
      ))}

      {/* Upload Section */}
      <div className="-mt-4 flex flex-col gap-4">
        <KdsText>
          {t("order.catalogMediumConfiguration.stepVersions.preMedia.addFile")}
        </KdsText>

        {fields.map(({ id }, index) => (
          <PreMediaUploadField
            key={id}
            id={id}
            index={index}
            orderItem={orderItem}
            isUploadingFile={isUploadingFile}
            onFileUpload={onFileUpload}
            ctx={ctx}
          />
        ))}
      </div>
    </>
  );
};
